/*
 * @Date: 2024-07-11 13:56:31
 * @Author: haodong chenghd@dreamdt.cn
 * @LastEditors: haodong chenghd@dreamdt.cn
 * @LastEditTime: 2024-07-11 14:09:15
 */
var isLoaded = false;
export default {
  load() {
    return import(/* webpackChunkName: "vxe-table-loader" */ "./libs/vxetable.js").then((install) => {
      if (!isLoaded) {
        Vue.use(install);
        import(/* webpackChunkName: "vxe-table-loader" */  "vxe-table/lib/style.css");
        isLoaded = true;
      }
    });
  }
};
